import { render, staticRenderFns } from "./AssistantEdit.vue?vue&type=template&id=e8985c88&scoped=true&"
import script from "./AssistantEdit.vue?vue&type=script&lang=js&"
export * from "./AssistantEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8985c88",
  null
  
)

export default component.exports